import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import AdcelerateMain from "./adcelerate/main";
import CreatorshieldMain from "./creatorshield/main";
import Boost from "./enfini/enfini-boost";
import Pay from "./enfini/enfini-pay";
import Shield from "./enfini/enfini-shield";
import EnfinityMain from "./enfinity/main";
import LoadingPage from "./loading-page";
import Task from "./task/enfini-task";
import VVV from "./vvv/main";

export default function LandingPage() {
  const landingPage = import.meta.env.VITE_LANDING_PAGE;

  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const section = document.getElementById(location.state.scrollTo);

      setTimeout(() => {
        if (section) {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);

      window.history.replaceState({}, document.title);
    }
  }, [location]);

  switch (landingPage) {
    case "shield":
      return <Shield service={landingPage} />;
    case "pay":
      return <Pay service={landingPage} />;
    case "boost":
      return <Boost service={landingPage} />;
    case "task":
      return <Task service={landingPage} />;
    case "adcelerate":
      return <AdcelerateMain service={landingPage} />;
    case "enfinity":
      return <EnfinityMain service={landingPage} />;
    case "vvv":
      return <VVV service={landingPage} />;
    case "creatorshield":
      return <CreatorshieldMain service={landingPage} />;
    default:
      return <LoadingPage />;
  }
}
